import ModalBase from '../../../ModalBase/ModalBase';

function TimerExpiredModal({ open, close }) {
  return (
    <ModalBase
      isOpen={open}
      header={<>Time&apos;s up!</>}
      body={<>The timer for this quiz has reached zero.</>}
      footer={
        <button
          className="btn modal-base-btn primary"
          onClick={() => {
            close();
          }}
        >
          Accept
        </button>
      }
    />
  );
}
export default TimerExpiredModal;
